module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_score2.e7c43.png";